import React from "react";

const Member = (props) => {
    const { name, role, avatar } = props.item;

    return (
        <div className="team__member__item">
            <div className="avatar">
                <img src={avatar} alt={name} />
            </div>
            <p className="name">{name}</p>
            <p className="role">{role}</p>
        </div>
    );
};

export const Advisor = (props) => {
    const { name, des } = props.item;
    return (
        <div className="team__advisors__item">
            <p className="name">{name}</p>
            <p className="role">{des}</p>
        </div>
    );
};

export default Member;
